import { render } from "./PrintingModal.vue?vue&type=template&id=22b0434f&scoped=true&ts=true"
import script from "./PrintingModal.vue?vue&type=script&lang=ts"
export * from "./PrintingModal.vue?vue&type=script&lang=ts"

import "./PrintingModal.vue?vue&type=style&index=0&id=22b0434f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b0434f"]])

export default __exports__